import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { GENERAL_ERROR_MESSAGE } from '@shared/models/messages';
import { SnackBarService } from '@shared/services/snack-bar.service';
import { catchError, EMPTY, Observable, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { FAST_TRACK_LOAD_ERROR_MESSAGE } from '../fast-track.constants';
import { FastTrackDetail } from '../fast-track.model';

@Injectable({ providedIn: 'root' })
export class FastTrackApiService {
  private readonly http = inject(HttpClient);
  private readonly messageService = inject(SnackBarService);
  private readonly url = `${environment.apiUrl}/v2/assessments`;

  getFastTrack$(assessmentId: number): Observable<FastTrackDetail> {
    return this.http.get<FastTrackDetail>(`${this.url}/${assessmentId}/fast-track`).pipe(
      catchError(() => {
        this.messageService.showPermanentError(FAST_TRACK_LOAD_ERROR_MESSAGE);
        return EMPTY;
      })
    );
  }

  confirmFastTrack$(assessmentId: number): Observable<void> {
    return this.http.post<void>(`${this.url}/${assessmentId}/fast-track/confirm`, null).pipe(
      catchError(error => {
        this.messageService.showError(`Failed to confirm Fast-track: ${error?.error?.message ?? GENERAL_ERROR_MESSAGE}`);
        return throwError(() => error);
      })
    );
  }

  declineFastTrack$(assessmentId: number): Observable<void> {
    return this.http.post<void>(`${this.url}/${assessmentId}/fast-track/decline`, null).pipe(
      catchError(error => {
        this.messageService.showError(`Failed to decline Fast-track: ${error?.error?.message ?? GENERAL_ERROR_MESSAGE}`);
        return throwError(() => error);
      })
    );
  }
}
